var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{style:(_vm.getStyleCell(_vm.value, _vm.percent))},[_vm._v("\n  "+_vm._s(_vm.percent)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }